import {
  DetailSectionCard, DetailSectionTitle, DetailTimeline,
  DetailTimelineItem, DetailTimelineMeta, DetailTimelineSkeletonItem,
  DetailTimelineSkeletonLine, DetailTimelineTitle,
} from "./detail.styles";

const SKELETON_ITEMS = [0, 1, 2];

export const AlertManagementTimeline = ({ items, loading }) => (
  <DetailSectionCard bordered={false}>
    <DetailSectionTitle>Traza de eventos</DetailSectionTitle>
    {loading ? (
      <DetailTimeline>
        {SKELETON_ITEMS.map((i) => (
          <DetailTimelineSkeletonItem key={i}>
            <DetailTimelineSkeletonLine $width="60%" />
            <DetailTimelineSkeletonLine $small $width="40%" />
          </DetailTimelineSkeletonItem>
        ))}
      </DetailTimeline>
    ) : (
      <DetailTimeline $scroll={items.length > 5}>
        {items.map((item) => (
          <DetailTimelineItem key={item.id} $tone={item.tone}>
            <DetailTimelineTitle>{item.title}</DetailTimelineTitle>
            <DetailTimelineMeta>{item.meta}</DetailTimelineMeta>
          </DetailTimelineItem>
        ))}
      </DetailTimeline>
    )}
  </DetailSectionCard>
);